import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type { GetStoresRequest, GetStoresResponse } from '@/modules/stores/types/get-stores';
import { ENDPOINT } from '../types/get-stores';
import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

export type UseCaseInput = GetStoresRequest;
export type UseCaseOutput = GetStoresResponse;

export class GetStoresUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { latitude, longitude } = input;

    if (!latitude || !longitude) {
      throw new Error('Latitude and longitude are required');
    }

    const response = await this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.POST,
      endpoint: ENDPOINT,
      body: input,
    });

    return response;
  }
}
